import type { JsonString } from '@openx/types/json.ts';

export type ParsedPdpError = ReturnType<typeof parsePdpErrorJson>;

export const parsePdpErrorJson = (error: JsonString) => {
  try {
    return JSON.parse(error) as { message?: string };
  } catch {
    return undefined;
  }
};
